import { mapGetters } from 'vuex';
export default {
  name: 'CoreMainAuthInclude',
  data: function () {
    return {
      host: window.location.hostname
    };
  },
  computed: {
    ...mapGetters({
      userId: 'authentication/userId'
    }),
    iframeSrc() {
      return `${window.location.origin}/mainAuthInclude.html#host=${this.host}`;
    }
  }
};